import React from 'react';
import CommandItemTable from '../CommandList';

function AmazonCommand({ onCommandChange, onAddCommand }) {

    const commandItems = [
        { command: 'keyword', description: 'amazon_keyword_description', type: 'text'},
        { command: '|', description: 'amazon_or_description', type: 'hidden', value: '|'},

        { command: '&low-price=', description: 'amazon_lowprice_description',value:'&high-price=' , type: 'number' },
        { command: '&high-price=', description: 'amazon_highprice_description',value:'&high-price=' , type: 'number' },
        { command: '&pct-off=', description: 'amazon_pctoff_description',value:'&pct-off=' , type: 'number', placeholder: '1~99 (%)' },

        { command: '&emi=AN1VRQENFRJN5', description: 'amazon_amazononly_description',value:'&emi=AN1VRQENFRJN5' , type: 'hidden' },
        { command: '&sort=popularity-rank', description: 'amazon_popularity-rank_description',value:'&sort=popularity-rank' , type: 'hidden' },

        { command: '&sort=salesrank', description: 'amazon_salesrank_description',value:'&sort=salesrank' , type: 'hidden' },
        { command: '&s=date-desc-rank', description: 'amazon_datedesc_description',value:'&s=date-desc-rank' , type: 'hidden' },
        { command: '&s=date-asc-rank', description: 'amazon_dateasc_description',value:'&s=date-asc-rank' , type: 'hidden' },
        { command: '&s=price-asc-rank', description: 'amazon_priceasc_description',value:'&s=price-asc-rank' , type: 'hidden' },
        { command: '&s=price-desc-rank', description: 'amazon_pricedesc_description',value:'&s=price-desc-rank' , type: 'hidden' },


        { command: '&s=review-rank', description: 'amazon_reviewrank_description',value:'&s=review-rank' , type: 'hidden' },
        { command: '&s=-review-rank', description: 'amazon_-reviewrank_description',value:'&s=-review-rank' , type: 'hidden' },

    ];

    return <CommandItemTable commandItems={commandItems} onCommandChange={onCommandChange} onAddCommand={onAddCommand} />
}

export default AmazonCommand;

